import { ListPaginationControls } from "@/components/ui/ListPaginationBar"
import { cn } from "@/lib/utils/helpers"
import { TRANSFER_LIST_PER_PAGE } from "../constants/transferProcess"
import type { TransferListingPaginationFooterProps } from "../types"

/** Residents / pending-apps footer — same layout as `ListPaginationBar` + transfer “Total Selected”. */
export function TransferListingPaginationFooter({
  pageOptions,
  perPage,
  totalSelectedDisplay,
  onPageChange,
  onPerPageChange,
  testIdPrefix,
  containerDataTestId,
  perPageSelectDataTestId,
}: TransferListingPaginationFooterProps) {
  const currentPage = pageOptions.current || 1
  const lastPage = pageOptions.last || 1
  const totalRecords = pageOptions.total ?? 0
  return (
    <div
      data-testid={containerDataTestId}
      className={cn(
        "flex flex-col items-stretch justify-between gap-3 border-t border-slate-100 bg-slate-50/50 px-3 py-3 sm:gap-4 sm:px-4 sm:py-3",
        "sm:flex-row sm:items-center",
      )}
    >
      <div
        className="text-center text-xs font-medium text-slate-500 sm:text-left sm:text-sm"
        data-testid={`${testIdPrefix}-pagination-footer-summary`}
      >
        Page <span className="font-bold text-slate-900">{currentPage}</span> of{" "}
        <span className="font-bold text-slate-900">{lastPage || 1}</span>
        <span className="mx-2 text-slate-300">|</span>
        Total <span className="font-bold text-slate-900">{totalRecords}</span> Records
        <span className="mx-2 text-slate-300">|</span>
        Total Selected: <span className="font-bold text-slate-900">{totalSelectedDisplay}</span>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-2 sm:justify-end">
        <ListPaginationControls
          currentPage={currentPage}
          totalPages={lastPage}
          onPageChange={onPageChange}
          testIdPrefix={testIdPrefix}
          placement="footer"
        />
        <div className="ml-2 flex items-center gap-2 sm:ml-4">
          <span
            className="text-xs font-semibold uppercase tracking-wider text-slate-400"
            data-testid={`${testIdPrefix}-per-page-label-footer`}
          >
            Rows
          </span>
          <select
            data-testid={perPageSelectDataTestId}
            className="block rounded-lg border border-slate-200 bg-white p-2 text-sm text-slate-700 focus:border-button focus:outline-none focus:ring-2 focus:ring-button/30"
            value={String(perPage)}
            onChange={(e) => onPerPageChange(Number(e.target.value))}
          >
            {TRANSFER_LIST_PER_PAGE.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  )
}
